<template>
	<v-container>
		<v-row v-if="error">
			<v-col cols="12" sm="6" offset-sm="3">
				<app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				
				<v-col>
					<p class="title">Page Layout Info</p>
				</v-col>
				<v-card>
					<v-card-text>
						<v-container>
							<form @submit.prevent="onSave">
								<v-row>
									<v-col cols="12" sm="6" offset-md="2">
										<img class="companyImage" :src="imageUrl" height="150" >
									</v-col>
									<!-- <v-col cols="12" sm="6">
										<img class="companyImage" :src="imageUrl" height="150" >
									</v-col> -->
								</v-row>

								<v-row>
									<v-col cols="12" sm="6" >
										<v-btn raised class="primary" @click="onPickFile">Upload Image</v-btn>
										<input
										type="file"
										style="display: none"
										ref="fileInput"
										accept="image/*"
										@change="onFilePicked">
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="6">
										<v-text-field
										name="CompanyName"
										label="Company Name"
										id="CompanyName"
										v-model="companyName"
										type="text"
										></v-text-field>
									</v-col>

									<v-col cols="6">
										<v-text-field
										name="companyPhone"
										label="Company Phone #"
										id="companyPhone"
										v-model="companyPhone"
										placeholder="555-456-7890"
										type="tel" 

										></v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12">
										<v-text-field
										name="CompanyWebsite"
										label="Company Website"
										id="CompanyWebsite"
										v-model="companyWebsite"
										type=""
										></v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12">
										<v-text-field
										name="CompanyFooter"
										label="Company Footer"
										id="CompanyFooter"
										v-model="footer"
										type="text"
										></v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12">
										<v-text-field
										name="PriceNote"
										label="Price Disclosure"
										id="PriceDisclosure"
										v-model="priceDisclosure"
										type="text"
										></v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col>
										<v-btn class="primary" type="submit" :disabled="loading" :loading="loading">
											Save Changes
										</v-btn>
									</v-col>
								</v-row>
							</form>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import AppSettings from './AppSettings.vue'
	export default {
		components: {AppSettings},
		data () {
			return {
				hi: ''

			}
		},
		computed: {
			User () {
				return this.$store.getters.user
			},
			company () {
				return this.$store.getters.company
			},
			error () {
				return this.$store.getters.error
			},
			loading () {
				return this.$store.getters.loading
			},
			image: {
				set(image){
					this.$store.commit('image', image)
				},
				get(){
					return this.company.image
				}
			},
			imageUrl: {
				set(imageUrl){
					this.$store.commit('imageUrl', imageUrl)
				},
				get(){
					return this.company.imageUrl
				}
			},
			companyName: {
				set(name){
					this.$store.commit('companyName', name)
				},
				get(){
					return this.company.companyName
				}
			},
			companyPhone: {
				set(phone){
					this.$store.commit('companyPhone', phone)
				},
				get(){
					return this.company.companyPhone
				}
			},
			companyWebsite: {
				set(companyWebsite){
					this.$store.commit('companyWebsite', companyWebsite)
				},
				get(){
					return this.company.companyWebsite
				}
			},
			footer: {
				set(footer) {
					this.$store.commit('footer', footer)
				},
				get() {
					return this.company.footer
				}
			},
			priceDisclosure: {
				set(note) {
					this.$store.commit('priceDisclosure', note)
				},
				get() {
					return this.company.priceDisclosure
				}
			},
		},
		watch: {
			User (value) {
				if (value !== null && value !== undefined) {
					this.$router.push('/options')
				}
			}
		},
		methods: {
			onSave () {
				let companyInfo = {
					image: this.image,
					companyName: this.companyName,
					companyPhone: this.companyPhone,
					companyWebsite: this.companyWebsite,
					footer: this.footer,
					priceDisclosure: this.priceDisclosure
				}
				this.$store.dispatch('updateCompanyInfo', companyInfo)
			// this.$store.commit('drawerMenu', false)
		},
		onPickFile () {
			this.$refs.fileInput.click()
		},
		onFilePicked (event) {
			const files = event.target.files
			let filename = files[0].name
			if (filename.lastIndexOf('.') <= 0) {
				return alert('Please add a valid file!')
			}
			const fileReader = new FileReader()
			fileReader.addEventListener('load', () => {
				this.$store.commit('imageUrl', fileReader.result)
			})
			fileReader.readAsDataURL(files[0])
				this.$store.commit('image', files[0])
			},
			onDismissed () {
				this.$store.dispatch('clearError')
			}

		}
	}
</script>
<style type="text/css" scoped>
	.companyImage {
		max-width: 100%;
	}

</style>